import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBilling } from '../context/BillingContext';

function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

type BannerVariant = 'danger' | 'warning' | 'info';

const VARIANT_STYLES: Record<BannerVariant, { textColor: string; btnBg: string }> = {
  danger: { textColor: '#dc2626', btnBg: '#dc2626' },
  warning: { textColor: '#b45309', btnBg: '#5271A5' },
  info: { textColor: '#8094ae', btnBg: '#5271A5' },
};

export default function TrialBanner(): React.JSX.Element | null {
  const { billingState, trialDaysRemaining, trialEnd } = useBilling();
  const navigate = useNavigate();

  let variant: BannerVariant;
  let text: string;
  let ctaLabel: string;

  if (billingState === 'billing_required') {
    variant = 'danger';
    text = 'Testphase beendet';
    ctaLabel = 'Zum Billing';
  } else if (billingState === 'trialing' && trialDaysRemaining <= 3) {
    variant = 'warning';
    const endFormatted = trialEnd ? formatDate(trialEnd) : '';
    text = endFormatted
      ? `Endet am ${endFormatted}`
      : `Noch ${trialDaysRemaining} Tage`;
    ctaLabel = 'Paket w\u00e4hlen';
  } else if (billingState === 'trialing') {
    variant = 'info';
    text = `Test \u2013 ${trialDaysRemaining} Tage`;
    ctaLabel = 'Paket w\u00e4hlen';
  } else {
    return null;
  }

  const styles = VARIANT_STYLES[variant];

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 72,
        right: 0,
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 10,
        padding: '6px 20px',
        background: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(8px)',
        borderTop: '1px solid rgba(14, 19, 51, 0.06)',
      }}
    >
      <span style={{ fontSize: 12, fontWeight: 600, color: styles.textColor }}>
        {text}
      </span>
      <button
        onClick={() => navigate('/settings/billing')}
        style={{
          background: styles.btnBg,
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          padding: '5px 12px',
          fontSize: 11,
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        {ctaLabel}
      </button>
    </div>
  );
}
